import DocumentSchema from '@components/DocumentSchema';
import type { Table } from 'schema-dts';
import { EarningsAndRevenueDataTable, TableWrapper } from './styled';
import { getEarningsAndRevenueHistoryRawDataProps } from '../../redux/selectors';
import { useSelector, shallowEqual } from 'react-redux';
import { formatCellData } from './utils';
import { useSummary } from '@/hooks/useCompany';
import { format } from 'date-fns';
import { CompanyReportTableRow } from '@/pages/CompanyReport/styled';
import { usePastTranslation } from '../../../../hooks/usePastTranslation';

export const EarningsAndRevenueHistoryTable = () => {
  const summary = useSummary();
  const companyId = summary.status === 'success' ? summary.companyId : '';
  const uniqueSymbol = summary.status === 'success' ? summary.uniqueSymbol : '';
  const tickerSymbol = summary.status === 'success' ? summary.tickerSymbol : '';
  const { pastRevenueData, reportingUnit, reportingCurrencyISO } = useSelector(
    (state) => getEarningsAndRevenueHistoryRawDataProps(state, { companyId }),
    shallowEqual
  );

  const t = usePastTranslation();

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: t('earningsHistory.table.title', { tickerSymbol }),
          about: t('earningsHistory.table.caption', {
            uniqueSymbol,
            reportingCurrencyISO,
            reportingUnit,
          }),
        }}
      />
      <TableWrapper>
        <EarningsAndRevenueDataTable data-cy-id="earnings-and-revenue-history-table">
          <caption>
            {t('earningsHistory.table.caption', {
              uniqueSymbol,
              reportingCurrencyISO,
              reportingUnit,
            })}
          </caption>
          <thead>
            <tr>
              <th>{t('earningsHistory.table.date')}</th>
              <th>{t('earningsHistory.table.revenue')}</th>
              <th>{t('earningsHistory.table.earnings')}</th>
              <th>{t('earningsHistory.table.gaExpenses')}</th>
              <th>{t('earningsHistory.table.rdExpenses')}</th>
            </tr>
          </thead>
          <tbody>
            {pastRevenueData.map(({ data, dateKey }, rowIdx) => {
              const selected = rowIdx === 0;
              const isValidRow = dateKey !== null;
              return isValidRow ? (
                <CompanyReportTableRow selected={selected} key={rowIdx}>
                  <td>{format(new Date(dateKey), 'dd MMM yy')}</td>
                  {data.map((info, cellIdx) => (
                    <td key={cellIdx}>{formatCellData(info)}</td>
                  ))}
                </CompanyReportTableRow>
              ) : null;
            })}
          </tbody>
        </EarningsAndRevenueDataTable>
      </TableWrapper>
    </>
  );
};
